export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://schaumburgallstars-backend.onrender.com";